export default {
  accepted: 'JobAccepted',
  started: 'JobStarted',
  completed: 'JobCompleted',
  succeeded: 'JobSucceeded',
  progress: 'JobProgress',
  failed: 'JobFailed'
};
